<!-- 公众号分组管理 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">公众号分组管理</div>
	
	<div style="margin-top: 20px;display: flex;">
		<div style="width: 200px;flex-shrink: 0;">
			<div class="big-menu-box" style="position: sticky;top: 80px;border-right: 1px solid #e8e8e8;">
				<div style="margin-bottom: 10px;cursor: default;">书城列表</div>
				<div class="left-menu-box" style="height: 100%;overflow-y: scroll;" :style="{'height': left_book_height + 'px'}">
					<div v-for="(item,index) in bookList" :key="index" class="left-label" 
					:class="[item.status?'select_menu':'']" 
					@click="changeBook(item,index)">
						<div style="flex: 1;padding-left: 15px;">{{item.label}}</div>
						<!-- <div v-if="item.status" style="width: 3px;height: 100%;background-color: #409eff;"></div> -->
					</div>
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div style="flex: 1;padding-left: 25px;">
			<div style="font-size: 20px;margin-bottom: 10px;margin-top: -5px;">{{channel_title_show}}</div>
			<div style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 10px;">
				<a-button @click="goAddGroups" type="primary" icon="plus" class="screen-box" >新建分组</a-button>
				<div style="display: flex;">
					<div class="screen-box">
						<!-- <div class="screen-label">模板标题</div> -->
						<a-input v-model="r_name" allowClear placeholder="请输入组名" style="width: 200px;"/>
					</div>
					
					
					<a-button @click="searchButton('button')" :loading="search_button_loading"  type="primary" icon="search" class="screen-box">搜索</a-button>
				</div>
			</div>
			
			<div>
				<!-- 表头 -->
				<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
					<div  v-for="(item,index) in rableTitle" :key="index" >
						<div class="table-th-cell" 
						:style="{'width':item.width + 'px',}">
							{{item.title}}
						</div>
					</div>
				</div>
				<!-- 表格内容 -->
				<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
					<!-- ID -->
					<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
						{{item.id}}
					</div>
					<!-- 组名 -->
					<div class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
						{{item.name}}
					</div>
					<!-- 公众号组 -->
					<div class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}" style="display: flex;flex-wrap: wrap;">
						<div v-for="(item_z,index_z) in item.gzh" :key="index_z" style="margin-right: 9px;margin-bottom: 3px;">
							{{item_z.gzh_name}}
						</div>
					</div>
					<!-- 操作 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}" style="display: flex;flex-wrap: wrap;">
						<div @click="tdCz(1,item)" style="margin-right: 10px;cursor: pointer;color: #62a8ea;">查看/编辑</div>
						<div @click="tdCz(2,item)" style="color: red;cursor: pointer;">删除</div>
					</div>
					<!-- 创建人 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
						{{item.admin_name}}
					</div>
					<!-- 创建时间 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
						{{item.created_at}}
					</div>
					<!-- 更新时间 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
						{{item.updated_at}}
					</div>
					
					
				</div>
				
				<!-- 表格内容为空时显示 -->
				<tableNull :tableShowData="tableShowData" :table_null_width="table_scroll_width"></tableNull>
			</div>
		</div>
	</div>
	
	<!-- 新增 -->
	<a-drawer
	  :title="`${add_drawer_title}分组`"
	  width="900px"
	  placement="right"
	  :closable="false"
	  :visible="add_visible"
	  @close="addCloseDrawer"
	>
		<div class="form-cell-box">
			<div class="class-title">分组名称</div>
				
			<a-input v-model="x_name" placeholder="请输入" style="width: 340px;" />
		</div>
		
		<div style="width: 100%;">
			<div v-for="(item,index) in gzhData" :key="index" style="margin-bottom: 25px;">
				<a-checkbox :indeterminate="item.indeterminate_all" :checked="item.checked_all" @change="onCheckAllChange($event,item,index)">
					{{item.label}}
				</a-checkbox>
				<div style="display: flex;align-items: center;flex-wrap: wrap;margin-left: 20px;margin-top: 10px;">
					<div v-for="(item_z,index_z) in item.value" :key="index_z" style="margin-bottom: 5px;margin-right: 10px;">
						<a-checkbox  :checked="item_z.checked_z" @change="onCheckChange($event,index,index_z)">
							{{item_z.gzh_name}}
						</a-checkbox>
					</div>
					
				</div>
			</div>
		</div>
		
		<div class="form-cell-box" style="margin-top: 30px;padding-left: 25px;">
			<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
			<a-button @click="addCloseDrawer">取消</a-button>
		</div>
	</a-drawer>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { materialChannelSelect, gzhGroupList, gzhGroupAdd, gzhGroupEdit, gzhGroupDel, gzhGroupGet } from '@/request/api'
export default {
	name: 'gzhGroups_',
	components: {
		
	},
	data() {
		return {
			bookList: [],
			left_book_height: 300, // 左边书城列表的高度
			
			search_button_loading: false,
			
			r_name: null, // 名称
			r_channel_id: null, // 渠道ID
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:90, type:"id", }, 
				{title:"组名", width:160, type:"name", },
				{title:"公众号组", width:180, type:"gzh", },
				{title:"操作", width:130, type:"cz", },
				{title:"创建人", width:130, type:"admin_name", },
				{title:"创建时间", width:150, type:"created_at", },
				{title:"更新时间", width:150, type:"updated_at", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			
			r_page: 1, // 页数
			r_limit: 50, // 每页多少条
			
			// 新增侧边栏
			add_drawer_title: "",
			add_visible: false,
			add_button_loading: false,
			x_name: null, // 新增-分组名称
			e_id: null, // 编辑用的id
			treeData: [],
			searchValue: '',
			gzhData: [], // 公众号分组的数据
			
			channel_title_show: "", // 选中的书城渠道名字
		}
	},
	mounted(){
		let that = this
		
		that.left_book_height = document.body.clientHeight - 65 - 20 - 36 -20 - 24 - 10 - 20 - 10
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		let body_width = document.body.clientWidth - 60 - 200 - 30
		that.rableTitle.forEach((res,index)=>{
			res.width = Math.round((res.width/nn)*body_width)
		})
		that.table_scroll_width = body_width
		
		
		
		materialChannelSelect().then(res=>{
			console.log("下拉",res);
			that.selectData = res.data.data
			let c_data = res.data.data.channel
			let show_data = []
			for (let key in c_data) {
				let ooo = {
					key,
					label: c_data[key],
					status: false,
				}
				show_data.push(ooo)
			}
			show_data[0].status = true
			that.channel_title_show = show_data[0].label
			that.r_channel_id = show_data[0].key // 获取渠道ID
			that.bookList = show_data
			console.log("show_data",show_data);
			
			// 获取分组的公众号
			that.groupGetReq()
		})
		
		
		that.searchButton()
	},
	methods: {
		// 切换书城列表
		changeBook(e,index){
			console.log("切换书城列表",e);
			
			this.channel_title_show = e.label
			
			this.bookList.forEach(res=>{
				res.status = false
			})
			this.bookList[index].status = true
			this.r_channel_id = e.key
			// 重新获取分组的公众号
			this.groupGetReq() // 不同渠道下的分组不一样
			
			this.searchButton()
			
		},
		// 获取该渠道下的公众号分组
		groupGetReq(){
			let that = this
			gzhGroupGet({
				channel_id: that.r_channel_id
			}).then(res=>{
				console.log("获取公众号用于分组",res);
				let data = res.data.data.list
				let arr = []
				for (let key in data) {
					let obj = {
						label: key,
						checked_all: false,
						indeterminate_all: false,
					}
					data[key].forEach(res=>{
						res.checked_z = false
					})
					obj.value = data[key]
					arr.push(obj)
				}
				console.log("arr",arr);
				that.gzhData = arr
				
				// let arr = []
				// for (let key in data) {
				// 	let obj = {
				// 		title: key,
				// 		// key: key,
				// 		children: data[key]
				// 	}
				// 	let zzz = data[key]
					
				// 	zzz.forEach(res=>{
				// 		res.title = res.gzh_name,
				// 		res.key = res.id,
				// 		res.children = []
				// 	})
					
				// 	arr.push(obj)
				// }
				// console.log("arr",arr);
				// that.treeData = arr
			})
		},
		
		
		// 新建分组
		goAddGroups(){
			this.add_drawer_title = "新建"
			this.add_visible = true
		},
		
		// 搜索
		searchButton(type){
			let that = this
			this.search_button_loading = true
			
			gzhGroupList({
				name: that.r_name,
				channel_id: that.r_channel_id
			}).then(res=>{
				console.log("列表搜索",res);
				that.search_button_loading = false
				
				that.tableShowData = res.data.data.data
			})
			
		},
		
		
		// 表格内操作
		tdCz(e,item){
			let that = this
			console.log("item",item);
			if(e == 1){ // 查看/编辑
				this.add_drawer_title = "查看/编辑"
				this.gzhData.forEach(res=>{
					res.value.forEach(res_z=>{
						item.gzh.forEach(res_g=>{
							if(res_g.id == res_z.id){
								res_z.checked_z = true
							}
						})
					})
				})
				this.x_name = item.name
				this.e_id = item.id
				this.add_visible = true
			}
			else if(e == 2){ // 删除
				this.$confirm({
					title: '确定要删除吗?',
					content: `组名：${item.name}`,
					okText: '删除',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
					  gzhGroupDel({
						  id: item.id
					  }).then(res=>{
						  console.log("删除",res);
						  if(res.data.code == 0){
							  that.$message.success('删除成功');
							  that.searchButton()
						  }
						  else {
							  if(res.data.code == 401){ // 未登录
							  	localStorage.removeItem("access_token");
							  	that.$router.replace({name: 'login',params: {type:'not_log'}})
							  }
							  else {
							  	that.$message.error(`错误：${res.data.msg}`);
							  }
						  }
					  })
					},
					onCancel() {
					  console.log('Cancel');
					},
				});
			}
		},
		
		// 新增侧边栏
		addRequest(){
			let that = this
				if(!that.x_name){
					that.$message.warning('请输入分组名称');
				}
				else {
					let i_data = [] // 把选中的公众号id放入里面
					that.gzhData.forEach(res=>{
						res.value.forEach(res_z=>{
							if(res_z.checked_z){
								i_data.push(res_z.id)
							}
						})
					})
					console.log("i_data",i_data)
					if(i_data.length == 0){
						that.$message.warning('请选择公众号');
						return
					}
					
					that.add_button_loading = true
					if(that.add_drawer_title == "新建"){
						gzhGroupAdd({
							channel_id: that.r_channel_id,
							name: that.x_name,
							gzh_id: i_data
						}).then(res=>{
							that.add_button_loading = false
							console.log("添加",res);
							if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
								that.$message.success('添加成功');
								that.addCloseDrawer()
								// 重新获取分组的公众号
								that.groupGetReq()
								
								that.searchButton()
							}
							else {
								if(res.data.code == 401){ // 未登录
									localStorage.removeItem("access_token");
									that.$router.replace({name: 'login',params: {type:'not_log'}})
								}
								else {
									that.$message.error(`错误：${res.data.msg}`);
								}
							}
						})
					}
					else if(that.add_drawer_title == "查看/编辑"){
						gzhGroupEdit({
							channel_id: that.r_channel_id,
							name: that.x_name,
							gzh_id: i_data,
							id: that.e_id,
						}).then(res=>{
							that.add_button_loading = false
							console.log("编辑",res);
							if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
								that.$message.success('编辑成功');
								that.addCloseDrawer()
								// 重新获取分组的公众号
								that.groupGetReq()
								
								that.searchButton()
							}
							else {
								if(res.data.code == 401){ // 未登录
									localStorage.removeItem("access_token");
									that.$router.replace({name: 'login',params: {type:'not_log'}})
								}
								else {
									that.$message.error(`错误：${res.data.msg}`);
								}
							}
						})
					}
				}
			
		},
		addCloseDrawer(){
			this.add_drawer_title = ""
			this.x_name = ""
			this.add_visible = false
			// if(this.add_drawer_title == "查看/编辑"){
				this.gzhData.forEach(res=>{
					res.value.forEach(res_z=>{
						res_z.checked_z = false
					})
				})
			// }
		},
		onTreeChange(e) {
			console.log("onTreeChange",e.target.value);
		      const value = e.target.value;
		      const expandedKeys = dataList
		        .map(item => {
		          if (item.title.indexOf(value) > -1) {
		            return getParentKey(item.key, gData);
		          }
		          return null;
		        })
		        .filter((item, i, self) => item && self.indexOf(item) === i);
		      Object.assign(this, {
		        expandedKeys,
		        searchValue: value,
		        autoExpandParent: true,
		      });
		},
		onCheck(value,event){
			console.log("treeData",this.treeData);
			console.log("onCheck-value",value);
			console.log("onCheck-event",event);
		},
		
		// 全选/取消全选
		onCheckAllChange(e,item,index){
			let that = this
			if(that.gzhData[index].checked_all){
				that.gzhData[index].value.forEach(res=>{
					res.checked_z = false
				})
				that.gzhData[index].checked_all = false
			}
			else {
				that.gzhData[index].value.forEach(res=>{
					res.checked_z = true
				})
				that.gzhData[index].checked_all = true
			}
		},
		// 单选
		onCheckChange(e,index,index_z){
			let that = this
			console.log(that.gzhData[index].value[index_z].id)
			that.gzhData[index].value[index_z].checked_z = !that.gzhData[index].value[index_z].checked_z
			
			let ttt = true // 用于判断是否全选
			that.gzhData[index].value.forEach(res=>{
				if(!res.checked_z){
					ttt = false
				}
			})
			if(ttt){
				that.gzhData[index].checked_all = true // 全选
			}
			else {
				that.gzhData[index].checked_all = false // 取消全选
			}
		},
	}
}
</script>

<style scoped>
.left-label {
	display: flex;
	justify-content: space-between;
	height: 36px;
	line-height: 36px;
	cursor: pointer;
	margin-bottom: 3px;
}
.left-label:hover {
	background-color: #f2f3f5;;
}
.select_menu {
	color: #1d99ff;
	background-color: #f2f3f5;;
}

.table-td-cell {
	font-size: 13px;
}


/* 设置左侧列滚动条开始 */
/* 滚动条整体 */
.left-menu-box::-webkit-scrollbar
{
	/* height决定横向scrollbar的高度，width决定纵向滚动条的宽度 */
    /* height:30px; */
	width: 7px;
    /* 默认：滚动条透明底色 */
    background-color: transparent;
}
/* 滚动条滑块 */
.left-menu-box::-webkit-scrollbar-thumb {
    /* 圆角 */
    border-radius: 10px;
    /* 滑块自身颜色 透明 */
    background-color: transparent;
}
/* 当鼠标hover时 */
.big-menu-box:hover .left-menu-box::-webkit-scrollbar {
	/* 底色 */
	background-color:#f3f3f3 !important;
}
.big-menu-box:hover .left-menu-box::-webkit-scrollbar-thumb {
	/* 滑块颜色 */
	background-color: #999 !important;
}
.left-menu-box::-webkit-scrollbar{
	/* display:none; */
	background-color: transparent;
}
/* 设置左侧列滚动条结束 */
</style>